<template>
  <el-dropdown ref="dropdown" placement="top-start" trigger="click">
    <span class="el-dropdown-link">
      <img class="icon pointer" src="@/assets/emoji.png" alt="表情" title="表情" />
    </span>
    <el-dropdown-menu slot="dropdown" class="picker-dropdown">
      <div class="picker-container">
        <div class="tabs-container">
          <el-tabs v-model="activeTab" class="picker-tabs" @tab-click="handleTabClick" :stretch="false">
            <el-tab-pane v-for="(category, index) in categories" :key="category" :name="index + ''">
              <span slot="label">
                <span v-if="category === 'Frequently used'" style="font-size: 20px;">🕒</span>
                <span v-else-if="emojiData[category] && emojiData[category][0]" style="font-size: 20px;">{{
                  emojiData[category][0] }}</span>
                <span v-else>{{ category }}</span>
              </span>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="content-container">
          <div class="emoji-grid" v-if="emojiList && emojiList.length > 0">
            <div v-for="(emoji, idx) in emojiList" :key="idx" class="emoji-item" @click="handleInsertEmoji(emoji)">
              <span class="emoji">{{ emoji }}</span>
            </div>
          </div>
        </div>
      </div>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import emojiData from '../utils/emoji.json'
export default {
  name: 'EmojiPicker',
  props: {
    onInsertEmoji: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      activeTab: '0',
      categories: Object.keys(emojiData),
      emojiList: [],
      emojiData: emojiData
    }
  },
  created() {
    this.emojiList = emojiData[this.categories[0]] || []
  },
  methods: {
    handleTabClick(tab) {
      this.activeTab = tab.name
      this.emojiList = emojiData[this.categories[tab.name]] || []
    },
    handleInsertEmoji(emoji) {
      this.onInsertEmoji && this.onInsertEmoji(emoji)
      // 关闭下拉菜单
      this.$nextTick(() => {
        if (this.$refs.dropdown) {
          this.$refs.dropdown.hide()
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.icon {
  width: 22px;
  height: 22px;
  margin-right: 20px;
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.1);
  }
}

.picker-dropdown {
  width: 420px;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  border: 1px solid #e4e7ed;
  overflow: hidden;
}

.picker-container {
  background: #fff;
}

.tabs-container {
  border-bottom: 1px solid #f0f0f0;
  background: #fafafa;
  padding: 8px 12px;
}

.picker-tabs {
  ::v-deep .el-tabs__header {
    margin: 0;
    border: none;
  }

  ::v-deep .el-tabs__nav-wrap {
    overflow-x: auto;
    overflow-y: hidden;
    scrollbar-width: none;
    -ms-overflow-style: none;
    border: none;
    position: relative;
    height: 48px;
    display: flex;
    align-items: center;

    &::-webkit-scrollbar {
      display: none;
    }

    &::after {
      height: 0;
    }
  }

  ::v-deep .el-tabs__nav {
    border: none;
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 0 4px;
  }

  ::v-deep .el-tabs__item {
    min-width: 40px;
    height: 40px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    background: transparent;
    margin: 0 2px;
    border-radius: 8px;
    transition: all 0.2s ease;
    position: relative;

    &:hover {
      background: #f0f0f0;
    }

    &.is-active {
      background: transparent;
      color: inherit;
      border-bottom: none;
    }

    &.is-active::after {
      content: '';
      display: block;
      position: absolute;
      left: 20%;
      right: 20%;
      bottom: 0;
      height: 3px;
      border-radius: 2px;
      background: #409EFF;
    }
  }

  ::v-deep .el-tabs__active-bar {
    display: none;
  }

  ::v-deep .el-tabs__nav-next,
  ::v-deep .el-tabs__nav-prev {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    background: rgba(255, 255, 255, 0.95);
    border: 1px solid #e4e7ed;
    border-radius: 6px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transition: all 0.2s ease;
    z-index: 10;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);

    &:hover {
      background: #fff;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }

    // &.is-disabled {
    //   opacity: 0.3;
    //   cursor: not-allowed;
    // }
  }

  ::v-deep .el-tabs__nav-prev {
    left: 4px;
  }

  ::v-deep .el-tabs__nav-next {
    right: 4px;
  }
}

.content-container {
  padding: 12px;
  background: #fff;
}

.emoji-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(44px, 1fr));
  gap: 4px;
  height: 180px;
  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }
}

.emoji-item {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #f0f8ff;
    transform: scale(1.1);
  }

  &:active {
    transform: scale(0.95);
  }
}

.emoji {
  font-size: 24px;
  user-select: none;
}
</style>